import React, { useState, useEffect } from 'react';
import {
  Container, Typography, Box, Paper, Grid, TextField, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, IconButton, Dialog, DialogTitle, DialogContent,
  DialogActions, FormControl, InputLabel, Select, MenuItem, Chip, Alert, Snackbar,
  Divider, Card, CardContent, CircularProgress, Pagination
} from '@mui/material';
import {
  Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon, Search as SearchIcon,
  Refresh as RefreshIcon, Save as SaveIcon, Print as PrintIcon
} from '@mui/icons-material';
import { apiService } from '../../services/api';
import {
  DailyReport as DailyReportType,
  DailyReportItem,
  TemperatureRecord,
  CreateDailyReportRequest,
  UpdateDailyReportRequest,
  DailyReportQueryRequest,
  DailyReportListResponse,
  DailyReportResponse,
  SiteTypeOption,
  DailyReportTemplate
} from '../../types/dailyReport';
import PageLayout from '../../components/Layout/PageLayout';
import BackButton from '../../components/BackButton';
import { useTranslation } from '../../hooks/useTranslation';
import { useTableSort } from '../../hooks/useTableSort';
import SortableTableHead from '../../components/Table/SortableTableHead';
import DailyReportForm from './DailyReportForm';

const DailyReportPage: React.FC = () => {
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' as 'success' | 'error' | 'info' | 'warning' });

  return (
    <PageLayout
      title={t('pages.dailyReport.title')}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      <DailyReportForm />
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert
            severity={snackbar.severity}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
    </PageLayout>
  );
};

export default DailyReportPage;